module.exports = __webpack_public_path__ + "img/icn_brand16_black.c32faba9.svg";